// extracted by mini-css-extract-plugin
export default {"switchButtonRow":"switchButtonRow_switchButtonRow__g-Yv4","switchTitle":"switchButtonRow_switchTitle__SX9Sf","switchDescription":"switchButtonRow_switchDescription__fIqwQ"};